module.exports = "<div class=\"deck row col-xs-offset-2 col-xs-8\">\n    <itpx-deliverable-tile-state-container *ngFor=\"let materialDetails of (sharedDeliverable$ | async); trackBy: trackByFn\"\n      [props]=\"materialDetails\" [sharedProfile$]=\"sharedProfile$\" [status$]=\"status$\">\n    </itpx-deliverable-tile-state-container>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/material/deliverable-stack-presentation/deliverable-stack-presentation.component.html
// module id = 940
// module chunks = 0